module.exports = __webpack_public_path__ + "img/提示-红.28249e80.svg";